__webpack_require__.p = "https://stagassets.1mg.com/pwa-app/jupiter/staging/dweb/2.0.1/static/";